import {HttpErrorResponse, HttpEvent, HttpHandlerFn, HttpInterceptorFn, HttpRequest} from '@angular/common/http';
import {from, lastValueFrom, Observable} from 'rxjs';
import {inject} from '@angular/core';
import {AuthService} from '../services/auth.service';
import {routeUrls} from '../constants/route-urls';
import {NavigationService} from '../services/ionic/navigation.service';

export const authInterceptor: HttpInterceptorFn = (httpRequest: HttpRequest<unknown>, httpHandlerFn: HttpHandlerFn): Observable<HttpEvent<unknown>> => {
  if (httpRequest.url.startsWith('https://${backend}')) {
    const authService: AuthService = inject(AuthService);
    const navigationService: NavigationService = inject(NavigationService);

    const intercept: () => Promise<HttpEvent<unknown>> = async (): Promise<HttpEvent<unknown>> => {
      const accessToken: string = authService.accessToken;

      if (accessToken) {
        httpRequest = httpRequest.clone({
          setHeaders: {
            Authorization: `Bearer ${accessToken}`
          }
        });
      }

      let response: HttpEvent<unknown>;

      try {
        response = await lastValueFrom(httpHandlerFn(httpRequest));
      } catch (err: any) {
        if (err instanceof HttpErrorResponse && err.status === 403) {
          await authService.logout();
          navigationService.navigateRootBack(routeUrls.login).catch((err: any): void => {
            throw err;
          });
        }
        throw err;
      }

      return response;
    }

    return from(intercept());
  }

  return httpHandlerFn(httpRequest);
}
